module.exports = __webpack_public_path__ + "img/feature_xj_bg.72941415.png";